import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import Stack from "@mui/material/Stack"
import React, { useEffect } from "react"
import DeleteIcon from "@mui/icons-material/Delete"
import { IСreateAvailableSchedule } from "../../../model/create/СreateAvailableSchedule"
import { SubmitHandler, useForm } from "react-hook-form"
import Typography from "@mui/material/Typography"
import TextField from "@mui/material/TextField"
import MenuItem from "@mui/material/MenuItem"
import { DatePicker, TimePicker } from "@mui/x-date-pickers"
import dayjs, { Dayjs } from "dayjs"
import WatchLaterIcon from "@mui/icons-material/WatchLater"
import DateRangeIcon from "@mui/icons-material/DateRange"
import LockClockIcon from "@mui/icons-material/LockClock"
import Popover from "@mui/material/Popover"
import {
  useGetDepartmentQuery,
  useGetLineQuery,
} from "../../../api/InterviewsApi"
import {
  useAddAvailableScheduleMutation,
  useDeleteAvailableScheduleMutation,
  useUpdateAvailableScheduleMutation,
} from "../../../api/ScheduleApi"
import { useSnackbar } from "notistack"

const CreateAvailableSchedule = ({
  open,
  setOpen,
  selects,
  editRow,
}: {
  open: any
  setOpen: any
  selects: any
  editRow: IСreateAvailableSchedule
  setEditRow: any
}) => {
  const {
    handleSubmit,
    formState,
    register,
    reset,
    watch,
    setValue,
    clearErrors,
    resetField,
  } = useForm<IСreateAvailableSchedule>({
    defaultValues: editRow,
  })

  const [
    addAvailableSchedule,
    { isSuccess: addIsSuccess, isError: addIsError },
  ] = useAddAvailableScheduleMutation()
  const [
    updateAvailableSchedule,
    { isSuccess: updateIsSuccess, isError: updateIsError },
  ] = useUpdateAvailableScheduleMutation()
  const [
    deleteAvailableSchedule,
    { isSuccess: deleteIsSuccess, isError: deleteIsError },
  ] = useDeleteAvailableScheduleMutation()

  const [confirmation, setСonfirmation] = React.useState<{
    type: string | null
    open: boolean
  }>({
    type: null,
    open: false,
  })

  const today = dayjs()
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const { enqueueSnackbar } = useSnackbar()

  const openPopover = Boolean(anchorEl)
  const id = openPopover ? "simple-popover" : undefined

  const onSubmit: SubmitHandler<IСreateAvailableSchedule> = async (
    data: IСreateAvailableSchedule,
  ) => {
    console.log(data, "1231")
    if (open.openCreateAvailableSchedule.type === "edit") {
      try {
        const response = await updateAvailableSchedule(data)
        setOpen({
          ...open,
          openCreateAvailableSchedule: { open: false },
        })
        reset({
          graphType: { id: null, name: null },
          schedule: {
            pattern: { id: null, name: null },
            startDate: null,
            endDate: null,
          },
          workDays: {
            startDate: null,
            endDate: null,
          },
          project: { id: null, name: null },
          department: { id: null, name: null },
          line: { id: null, name: null },
          dropoutRate: null,

          scheduleQuantity: null,
          requirement: {
            startDate: null,
            endDate: null,
            status: null,
          },
        })
        console.log(response)
      } catch (error) {
        enqueueSnackbar("Ошибка при обновлении графика", { variant: "error" })
        console.error("Error updating interview:", error)
      }
    } else
      try {
        const updatedData = {
          ...data,
          schedule: {
            pattern: {
              id: data.schedule.pattern.id,
              name: data.schedule.pattern.name,
            },
            startDate: dayjs(data.schedule.startDate).add(3, "hour"),
            endDate: dayjs(data.schedule.endDate).add(3, "hour"),
          },
          dropoutRate: line?.data?.dropoutRate,
        }
        const response = await addAvailableSchedule(updatedData)
        setOpen({
          ...open,
          openCreateAvailableSchedule: { open: false },
        })
        reset({
          graphType: { id: null, name: null },
          schedule: {
            pattern: { id: null, name: null },
            startDate: null,
            endDate: null,
          },
          project: { id: null, name: null },
          department: { id: null, name: null },
          line: { id: null, name: null },
          dropoutRate: null,

          scheduleQuantity: null,
          requirement: {
            startDate: null,
            endDate: null,
          },
        })
        console.log(response)
      } catch (error) {
        console.error("Error adding interview:", error)
        enqueueSnackbar("Ошибка при добавлении графика", { variant: "error" })
      }
  }

  const onSubmitDelete: SubmitHandler<IСreateAvailableSchedule> = async (
    data: IСreateAvailableSchedule,
  ) => {
    if (confirmation.type === "delete")
      try {
        const response = await deleteAvailableSchedule(data)
        setOpen({
          ...open,
          openCreateAvailableSchedule: { open: false },
        })
        console.log(response)
      } catch (error) {
        console.error("Error deleting interview:", error)
      }
  }

  const department = useGetDepartmentQuery(`${watch("project.id")}&type=add`, {
    skip: !watch("project.id"),
  })

  const line = useGetLineQuery(`${watch("department.id")}&type=add`, {
    skip: !watch("department.id"),
  })

  const { errors } = formState

  useEffect(() => {
    if (addIsError) {
      enqueueSnackbar("Ошибка при добавлении графика", { variant: "error" })
    }
    if (addIsSuccess) {
      enqueueSnackbar("График добавлен", { variant: "success" })
    }
    if (deleteIsError) {
      enqueueSnackbar("Ошибка при удалении графика", { variant: "error" })
    }
    if (deleteIsSuccess) {
      enqueueSnackbar("График удален", { variant: "success" })
    }
    if (updateIsError) {
      enqueueSnackbar("Ошибка при обновлении графика", { variant: "error" })
    }
    if (updateIsSuccess) {
      enqueueSnackbar("График обновлен", { variant: "success" })
    }
  }, [
    addIsError,
    addIsSuccess,
    deleteIsError,
    deleteIsSuccess,
    updateIsError,
    updateIsSuccess,
  ])

  const isDisabledActiveSchedule =
    Number(editRow.activeSchedule) <= Number(watch("scheduleQuantity"))

  return (
    <Dialog
      maxWidth={"lg"}
      sx={{
        ".MuiDialogContent-root": { px: "43px", pb: "25px" },
        ".MuiDialogActions-root": { px: "43px" },
        ".MuiDialogTitle-root": { px: "43px" },
        ".MuiDialog-paper": {
          width: "835px",
          backgroundColor: "background.paper",
        },
      }}
      open={open.openCreateAvailableSchedule.open}
      keepMounted
      onClose={() =>
        setOpen({
          ...open,
          openCreateAvailableSchedule: { open: false },
        })
      }
    >
      {/* <Box sx={{ px: "28px", py: "14px", width: "720px" }}> */}
      <DialogTitle
        sx={{
          fontWeight: "bold",
          position: "sticky",
          top: 0,
          backgroundColor: "background.paper",
          zIndex: 100,
        }}
      >
        {open.openCreateAvailableSchedule?.type === "add"
          ? "Добавление графика"
          : "Редактирование графика"}
      </DialogTitle>
      <form
        onSubmit={
          confirmation.type !== "delete" ? handleSubmit(onSubmit) : undefined
        }
      >
        <DialogContent>
          <Stack direction="column" spacing={"30px"}>
            <Stack direction="column" spacing={"20px"}>
              <Stack direction={"column"} spacing={"5px"}>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: "bold",
                  }}
                >
                  Тип графика *
                </Typography>
                <TextField
                  disabled={
                    open.openCreateAvailableSchedule.type === "edit" &&
                    !watch("isEditable")
                      ? true
                      : false
                  }
                  size="small"
                  label="Тип графика"
                  inputProps={register("graphType.id", {
                    required: "Это поле обязательно для заполнения",
                  })}
                  error={Boolean(errors?.graphType)}
                  helperText={errors?.graphType?.message}
                  fullWidth
                  value={watch("graphType.id")}
                  id="outlined-select-currency"
                  select
                >
                  {selects?.availableSchedule.graphType.map((option: any) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Stack>
              <Stack direction={"column"} spacing={"5px"}>
                <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                  График *
                </Typography>
                <TextField
                  disabled={
                    open.openCreateAvailableSchedule.type === "edit" &&
                    !watch("isEditable")
                      ? true
                      : false
                  }
                  size="small"
                  label="График"
                  inputProps={register("schedule.pattern.id", {
                    required: "Это поле обязательно для заполнения",
                  })}
                  error={Boolean(errors?.schedule?.pattern)}
                  helperText={errors?.schedule?.pattern?.message}
                  fullWidth
                  value={watch("schedule.pattern.id")}
                  id="outlined-select-currency"
                  select
                >
                  {selects?.availableSchedule.schedulePattern.map(
                    (option: any) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ),
                  )}
                </TextField>
                <Stack
                  alignItems={"center"}
                  justifyContent={"center"}
                  direction={"row"}
                  spacing={"5px"}
                  sx={{}}
                >
                  <TimePicker
                    disabled={
                      open.openCreateAvailableSchedule.type === "edit" &&
                      !watch("isEditable")
                        ? true
                        : false
                    }
                    slots={{
                      openPickerIcon: WatchLaterIcon,
                    }}
                    sx={{
                      ".MuiIconButton-root": {
                        color: "rgba(139, 139, 139, 1)",
                      },
                      minHeight:
                        Boolean(errors?.schedule?.startDate) ||
                        Boolean(errors?.schedule?.endDate)
                          ? "64px"
                          : "auto",
                    }}
                    value={
                      watch("schedule.startDate")
                        ? dayjs.utc(watch("schedule.startDate"))
                        : null
                    }
                    localeText={{
                      toolbarTitle: "ЧЧ.ММ",
                      fieldHoursPlaceholder: () => "ЧЧ",
                      fieldMinutesPlaceholder: () => "ММ",
                    }}
                    onChange={(e: Dayjs | null) => {
                      dayjs(e).isValid() && clearErrors("schedule.startDate")
                      setValue("schedule.startDate", dayjs.utc(e))
                    }}
                    format="HH:mm"
                    slotProps={{
                      textField: {
                        inputProps: register("schedule.startDate", {
                          required: "Это поле обязательно для заполнения",
                        }),

                        size: "small",
                        variant: "outlined",
                        placeholder: "ЧЧ.ММ",
                        fullWidth: true,
                        error: Boolean(errors?.schedule?.startDate),
                        helperText: errors?.schedule?.startDate?.message,
                      },
                    }}
                  />
                  <div
                    style={{
                      width: "10px",
                      height: "1px",
                      background: "#CACACA",
                      borderRadius: 4,
                    }}
                  />
                  <TimePicker
                    disabled={
                      open.openCreateAvailableSchedule.type === "edit" &&
                      !watch("isEditable")
                        ? true
                        : false
                    }
                    slots={{
                      openPickerIcon: WatchLaterIcon,
                    }}
                    sx={{
                      ".MuiIconButton-root": {
                        color: "rgba(139, 139, 139, 1)",
                      },
                      minHeight:
                        Boolean(errors?.schedule?.startDate) ||
                        Boolean(errors?.schedule?.endDate)
                          ? "64px"
                          : "auto",
                    }}
                    value={
                      watch("schedule.endDate")
                        ? dayjs.utc(watch("schedule.endDate"))
                        : null
                    }
                    localeText={{
                      toolbarTitle: "ЧЧ.ММ",
                      fieldHoursPlaceholder: () => "ЧЧ",
                      fieldMinutesPlaceholder: () => "ММ",
                    }}
                    onChange={(e: Dayjs | null) => {
                      dayjs(e).isValid() && clearErrors("schedule.endDate")
                      setValue("schedule.endDate", dayjs.utc(e))
                    }}
                    format="HH:mm"
                    slotProps={{
                      textField: {
                        inputProps: register("schedule.endDate", {
                          required: "Это поле обязательно для заполнения",
                        }),

                        size: "small",
                        variant: "outlined",
                        placeholder: "ЧЧ.ММ",
                        fullWidth: true,
                        error: Boolean(errors?.schedule?.endDate),
                        helperText: errors?.schedule?.endDate?.message,
                      },
                    }}
                  />
                </Stack>
              </Stack>
              <Stack direction={"column"} spacing={"5px"}>
                <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                  Рабочие дни *
                </Typography>

                <Stack
                  alignItems={"center"}
                  justifyContent={"center"}
                  direction={"row"}
                  spacing={"5px"}
                >
                  <DatePicker
                    disabled={
                      open.openCreateAvailableSchedule.type === "edit" &&
                      !watch("isEditable")
                        ? true
                        : false
                    }
                    slots={{
                      openPickerIcon: DateRangeIcon,
                    }}
                    sx={{
                      ".MuiIconButton-root": {
                        color: "rgba(139, 139, 139, 1)",
                      },
                      minHeight:
                        Boolean(errors?.workDays?.startDate) ||
                        Boolean(errors?.workDays?.endDate)
                          ? "64px"
                          : "auto",
                    }}
                    value={dayjs(watch("workDays.startDate")) || null}
                    localeText={{
                      toolbarTitle: "ЧЧ.ММ.ГГГГ",
                      fieldDayPlaceholder: () => "ДД",
                      fieldMonthPlaceholder: () => "ММ",
                      fieldYearPlaceholder: () => "ГГГГ",
                    }}
                    onChange={(e: Dayjs | null) => {
                      dayjs(e).isValid() &&
                        setValue(
                          "workDays.startDate",
                          dayjs(e).format("YYYY-MM-DDTHH:mm:ssZ"),
                        )
                    }}
                    format="DD.MM.YYYY"
                    slotProps={{
                      textField: {
                        inputProps: register("workDays.startDate", {
                          required: "Это поле обязательно для заполнения",
                        }),
                        size: "small",
                        variant: "outlined",
                        placeholder: "ДД.ММ.ГГГГ",
                        fullWidth: true,
                        error: Boolean(errors.workDays?.startDate),
                        helperText: errors.workDays?.startDate?.message,
                      },
                    }}
                  />
                  <div
                    style={{
                      width: "10px",
                      height: "1px",
                      background: "#CACACA",
                      borderRadius: 4,
                    }}
                  />
                  <DatePicker
                    disabled={
                      open.openCreateAvailableSchedule.type === "edit" &&
                      !watch("isEditable")
                        ? true
                        : false
                    }
                    slots={{
                      openPickerIcon: DateRangeIcon,
                    }}
                    sx={{
                      ".MuiIconButton-root": {
                        color: "rgba(139, 139, 139, 1)",
                      },
                      minHeight:
                        Boolean(errors?.workDays?.startDate) ||
                        Boolean(errors?.workDays?.endDate)
                          ? "64px"
                          : "auto",
                    }}
                    value={dayjs(watch("workDays.endDate")) || null}
                    localeText={{
                      toolbarTitle: "ЧЧ.ММ.ГГГГ",
                      fieldDayPlaceholder: () => "ДД",
                      fieldMonthPlaceholder: () => "ММ",
                      fieldYearPlaceholder: () => "ГГГГ",
                    }}
                    onChange={(e: Dayjs | null) => {
                      dayjs(e).isValid() && clearErrors("workDays.endDate")
                      setValue(
                        "workDays.endDate",
                        dayjs(e).format("YYYY-MM-DDTHH:mm:ssZ"),
                      )
                    }}
                    format="DD.MM.YYYY"
                    slotProps={{
                      textField: {
                        inputProps: register("workDays.endDate", {
                          required: "Это поле обязательно для заполнения",
                        }),
                        size: "small",
                        variant: "outlined",
                        placeholder: "ДД.ММ.ГГГГ",
                        fullWidth: true,
                        error: Boolean(errors.workDays?.endDate),
                        helperText: errors.workDays?.endDate?.message,
                      },
                    }}
                  />
                </Stack>
              </Stack>
              <Stack direction={"column"} spacing={"5px"}>
                <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                  Проект *
                </Typography>
                <TextField
                  disabled={
                    open.openCreateAvailableSchedule.type === "edit" &&
                    !watch("isEditable")
                      ? true
                      : false
                  }
                  size="small"
                  label="Проект"
                  inputProps={register("project.id", {
                    required: "Это поле обязательно для заполнения",
                  })}
                  fullWidth
                  value={watch("project.id")}
                  id="outlined-select-currency"
                  select
                  error={Boolean(errors?.project)}
                  helperText={errors?.project?.message}
                >
                  {selects?.availableSchedule?.project.map((option: any) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Stack>
              <Stack direction={"column"} spacing={"5px"}>
                <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                  Направление *
                </Typography>
                <TextField
                  disabled={
                    !department?.data ||
                    (open.openCreateAvailableSchedule.type === "edit" &&
                      !watch("isEditable"))
                      ? true
                      : false
                  }
                  size="small"
                  label="Направление"
                  inputProps={register("department.id", {
                    required: "Это поле обязательно для заполнения",
                  })}
                  fullWidth
                  value={watch("department.id")}
                  id="outlined-select-currency"
                  select
                  onChange={() => resetField("line")}
                  error={Boolean(errors?.department)}
                  helperText={errors?.department?.message}
                >
                  {department.data?.map((option: any) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Stack>
              <Stack direction={"column"} spacing={"5px"}>
                <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                  Линия *
                </Typography>
                <TextField
                  disabled={
                    !line.data ||
                    (open.openCreateAvailableSchedule.type === "edit" &&
                      !watch("isEditable"))
                      ? true
                      : false
                  }
                  size="small"
                  label="Линия"
                  inputProps={register("line.id", {
                    required: "Это поле обязательно для заполнения",
                  })}
                  fullWidth
                  value={watch("line.id")}
                  id="outlined-select-currency"
                  select
                  error={Boolean(errors?.line)}
                  helperText={errors?.line?.message}
                >
                  {line.data?.data.map((option: any) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Stack>
              <Stack direction={"column"} spacing={"5px"}>
                <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                  Количество графиков *
                </Typography>
                <Typography sx={{ fontSize: 10 }}>
                  Минимум {line?.data?.activeSchedule}
                </Typography>
                <TextField
                  type="number"
                  size="small"
                  inputProps={{
                    ...register("scheduleQuantity", {
                      required: "Это поле обязательно для заполнения",
                    }),
                  }}
                  fullWidth
                  value={watch("scheduleQuantity")}
                  placeholder="Количество графиков"
                  error={Boolean(errors.scheduleQuantity)}
                  helperText={errors.scheduleQuantity?.message || ""}
                />
              </Stack>
              <Stack direction={"column"} spacing={"5px"}>
                <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                  Процент отсева
                </Typography>
                <TextField
                  disabled
                  size="small"
                  fullWidth
                  value={
                    open.openCreateAvailableSchedule.type === "edit"
                      ? editRow?.dropoutRate
                      : line?.data?.dropoutRate
                      ? `${line?.data?.dropoutRate}%`
                      : null
                  }
                  placeholder="Процент отсева"
                />
              </Stack>
              <Stack direction={"column"} spacing={"5px"}>
                <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                  Дата открытия и закрытия потребности *
                </Typography>
                <Stack
                  alignItems={"center"}
                  justifyContent={"center"}
                  direction={"row"}
                  spacing={"5px"}
                >
                  <DatePicker
                    minDate={today}
                    slots={{
                      openPickerIcon: DateRangeIcon,
                    }}
                    sx={{
                      ".MuiIconButton-root": {
                        color: "rgba(139, 139, 139, 1)",
                      },
                      minHeight:
                        Boolean(errors?.requirement?.startDate) ||
                        Boolean(errors?.requirement?.endDate)
                          ? "64px"
                          : "auto",
                    }}
                    value={dayjs(watch("requirement.startDate")) || null}
                    localeText={{
                      toolbarTitle: "ЧЧ.ММ.ГГГГ",
                      fieldDayPlaceholder: () => "ДД",
                      fieldMonthPlaceholder: () => "ММ",
                      fieldYearPlaceholder: () => "ГГГГ",
                    }}
                    onChange={(e: Dayjs | null) => {
                      dayjs(e).isValid() && clearErrors("requirement.startDate")
                      setValue(
                        "requirement.startDate",
                        dayjs(e).format("YYYY-MM-DDTHH:mm:ssZ"),
                      )
                    }}
                    format="DD.MM.YYYY"
                    slotProps={{
                      textField: {
                        inputProps: register("requirement.startDate", {
                          required: "Это поле обязательно для заполнения",
                        }),
                        size: "small",
                        variant: "outlined",
                        placeholder: "ДД.ММ.ГГГГ",
                        fullWidth: true,
                        error: Boolean(errors.requirement?.startDate),
                        helperText: errors.requirement?.startDate?.message,
                      },
                    }}
                  />
                  <div
                    style={{
                      width: "10px",
                      height: "1px",
                      background: "#CACACA",
                      borderRadius: 4,
                    }}
                  />
                  <DatePicker
                    minDate={today}
                    slots={{
                      openPickerIcon: DateRangeIcon,
                    }}
                    sx={{
                      ".MuiIconButton-root": {
                        color: "rgba(139, 139, 139, 1)",
                      },
                      minHeight:
                        Boolean(errors?.requirement?.startDate) ||
                        Boolean(errors?.requirement?.endDate)
                          ? "64px"
                          : "auto",
                    }}
                    value={dayjs(watch("requirement.endDate")) || null}
                    localeText={{
                      toolbarTitle: "ЧЧ.ММ.ГГГГ",
                      fieldDayPlaceholder: () => "ДД",
                      fieldMonthPlaceholder: () => "ММ",
                      fieldYearPlaceholder: () => "ГГГГ",
                    }}
                    onChange={(e: Dayjs | null) => {
                      dayjs(e).isValid() && clearErrors("requirement.endDate")
                      setValue(
                        "requirement.endDate",
                        dayjs(e).format("YYYY-MM-DDTHH:mm:ssZ"),
                      )
                    }}
                    format="DD.MM.YYYY"
                    slotProps={{
                      textField: {
                        inputProps: register("requirement.endDate", {
                          required: "Это поле обязательно для заполнения",
                        }),
                        size: "small",
                        variant: "outlined",
                        placeholder: "ДД.ММ.ГГГГ",
                        fullWidth: true,
                        error: Boolean(errors.requirement?.endDate),
                        helperText: errors.requirement?.endDate?.message,
                      },
                    }}
                  />
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions
          sx={{ position: "sticky", bottom: 0, bgcolor: "background.paper" }}
        >
          <Stack
            direction="row"
            justifyContent={
              open.openCreateAvailableSchedule.type === "edit"
                ? "space-between"
                : "flex-end"
            }
            sx={{ width: "100%" }}
          >
            <Popover
              id={id}
              open={openPopover}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <form
                  onSubmit={
                    watch("isDeletable")
                      ? handleSubmit(onSubmitDelete)
                      : undefined
                  }
                >
                  <Stack
                    sx={{
                      px: "20px",
                      py: "10px",
                    }}
                    spacing={"50px"}
                    alignItems="center"
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
                      {confirmation.type === "delete"
                        ? "Вы уверены, что хотите удалить график?"
                        : "Вы уверены, что хотите закрыть потребность?"}
                    </Typography>
                    <Stack direction={"row"} spacing={"10px"}>
                      <Button
                        sx={{ fontWeight: "bold" }}
                        variant="outlined"
                        onClick={() => setAnchorEl(null)}
                        size="small"
                      >
                        Отмена
                      </Button>
                      <Button
                        size="small"
                        sx={{ fontWeight: "bold" }}
                        variant="contained"
                        onClick={() => {
                          setValue("requirement.status", "completed")
                        }}
                        type="submit"
                      >
                        Да
                      </Button>
                    </Stack>
                  </Stack>
                </form>
              </Stack>
            </Popover>
            {open.openCreateAvailableSchedule.type === "edit" && (
              <Stack direction="row" spacing="10px">
                {editRow.requirement.status !== "completed" && (
                  <Button
                    startIcon={<LockClockIcon />}
                    color="warning"
                    sx={{ fontWeight: "bold" }}
                    variant="contained"
                    onClick={(event) => {
                      setСonfirmation({
                        ...confirmation,
                        open: true,
                        type: "edit",
                      })
                      handleClick(event)
                    }}
                    size="large"
                  >
                    Закрыть потребность
                  </Button>
                )}
                {watch("isDeletable") && (
                  <Button
                    startIcon={<DeleteIcon />}
                    color="error"
                    sx={{ fontWeight: "bold" }}
                    variant="outlined"
                    size="large"
                    onClick={(event) => {
                      setСonfirmation({
                        ...confirmation,
                        open: true,
                        type: "delete",
                      })
                      handleClick(event)
                    }}
                  >
                    Удалить
                  </Button>
                )}
              </Stack>
            )}
            <Stack direction="row" spacing="10px">
              <Button
                size="large"
                sx={{ fontWeight: "bold" }}
                variant="outlined"
                onClick={() =>
                  setOpen({
                    ...open,
                    openCreateAvailableSchedule: { open: false },
                  })
                }
              >
                Отмена
              </Button>

              <Button
                disabled={
                  !isDisabledActiveSchedule || !watch("scheduleQuantity")
                }
                size="large"
                sx={{ fontWeight: "bold" }}
                variant="contained"
                type="submit"
              >
                {open.openCreateAvailableSchedule.type === "edit"
                  ? "Сохранить"
                  : "Добавить"}
              </Button>
            </Stack>
          </Stack>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default CreateAvailableSchedule
